import type { OnboardingStepKey } from "@/features/legal/config/onboarding.config";

type BuildOnboardingStepsOptions = {
  hasSecurityStep: boolean
  hasLegalSteps: boolean
};

// Only steps known to happen are listed: while the security check runs, the
// legal steps are not announced yet, since the account may not need them.
export const buildOnboardingSteps = ({ hasSecurityStep, hasLegalSteps }: BuildOnboardingStepsOptions): OnboardingStepKey[] => [
  ...(hasSecurityStep ? ["security" as const] : []),
  ...(hasLegalSteps ? ["legal" as const, "preferences" as const, "ready" as const] : []),
];
